module.exports = __webpack_public_path__ + "static/media/insurance_icon_white.c7bb41d7.svg";